const BERGEN_IMG = "/images/bergen.webp";

const FACTS = [
  { k: "Host city", v: "Bergen, Norway" },
  { k: "Direct flights", v: "London · Amsterdam · Copenhagen · Oslo" },
  { k: "Airport to centre", v: "30 min by light rail" },
  { k: "Waterfront to venue", v: "10 min walk" },
];

export default function Venue() {
  return (
    <section
      id="bergen"
      data-testid="venue-section"
      className="section border-t border-[var(--rule)]"
    >
      <div className="max-w-page container-x">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-12 md:mb-16">
          <div className="md:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="section-index">05</span>
              <span className="eyebrow" data-testid="venue-eyebrow">
                Bergen · Host city
              </span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl md:text-6xl leading-[0.98] tracking-[-0.02em] max-w-[16ch]">
              A city that rewards focus.
            </h2>
          </div>
          <div className="md:col-span-4 md:col-start-9 flex md:items-end">
            <p className="text-[14px] md:text-[15px] text-[var(--fg-muted)] leading-[1.55] max-w-[38ch]">
              Small enough to slow down. Serious enough to be taken seriously.
              Everything within a ten-minute walk.
            </p>
          </div>
        </div>

        <div className="aspect-[4/3] md:aspect-[21/10] w-full overflow-hidden bg-[var(--bg-2)]">
          <img
            src={BERGEN_IMG}
            alt="Bryggen in Bergen at blue hour — the Hanseatic wharf reflected in the harbour"
            loading="lazy"
            className="w-full h-full object-cover img-editorial"
            data-testid="venue-image"
          />
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-7 gap-x-6 border-b border-[var(--rule-soft)] py-6 md:py-7">
          {FACTS.map((f, i) => (
            <div
              key={f.k}
              className={`flex flex-col gap-2 ${
                i > 0 ? "md:border-l md:border-[var(--rule-soft)] md:pl-7" : ""
              }`}
              data-testid={`venue-fact-${f.k.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <span className="text-[10px] uppercase tracking-[0.24em] text-[var(--fg-muted)] font-semibold">
                {f.k}
              </span>
              <span className="text-[15px] leading-[1.35]">{f.v}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
